<app-notifications></app-notifications>
<app-notification-establishment></app-notification-establishment>
<router-outlet></router-outlet>
<layouts-no-has-internet></layouts-no-has-internet>
<!-- Modal de producto global -->
@if (showProductModal && selectedProduct) {
  <establishment-main-modal-view-product
    [product]="selectedProduct"
    (close)="closeProductModal()"
  ></establishment-main-modal-view-product>
}
<!-- Modal de devolución de dinero global -->
<devolucion-dinero></devolucion-dinero>

<!-- Componente global de confetti/fuegos artificiales -->
<shared-confetti></shared-confetti>
